import React, { useContext, useState } from 'react';
import { RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import styles from './RPSOneCallRolloverAdditionalFundsScreen.css';
import Heading from '../../components/Typography/Heading/Heading';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { enableContinueBtn } from './util';
import {
  getOCRPageTitle,
  getOCRSpecialTextOne,
  getOCRSpecialTextTwo,
  getRadioTitle
} from '../../flows/front-office/ocr-flows/utils';

const RPSOneCallRolloverAdditionalFundsScreen = () => {
  const { next, appState } = useContext(FlowContext);

  const {
    store: { accountType }
  } = appState;

  // set initial state to empty string for all the options
  const [companyStockFlag, setCompanyStockFlag] = useState('');
  const [rothHoldingsAfterTaxFlag, setRothHoldingsAfterTaxFlag] = useState('');

  const shouldEnableContinueBtn = enableContinueBtn(
    companyStockFlag,
    rothHoldingsAfterTaxFlag
  );

  const pageTitle = getOCRPageTitle(accountType);

  const handleCompanyStock = ({ target: { value } }) => {
    setCompanyStockFlag(value);
  };

  const handleRothHoldingsAfterTax = ({ target: { value } }) => {
    setRothHoldingsAfterTaxFlag(value);
  };

  const radioOptions = [
    {
      title: 'Yes',
      value: 'YES'
    },
    {
      title: 'N/A',
      value: 'N/A'
    }
  ];

  return (
    <div className="ocr-wizard-wrapper">
      <div className="ocr-wizard-section1">
        <Heading text={pageTitle} />

        <div className="special-text">{getOCRSpecialTextOne(accountType)}</div>

        <RadioGroupField
          title="As part of this process, you will need to liquidate company stock. Please confirm that you understand you may lose possible tax advantages of retaining company stock, that has significantly appreciated in value, in a non-retirement account."
          onChange={handleCompanyStock}
          options={radioOptions}
          name="companyStock"
        />

        <div className="special-text">{getOCRSpecialTextTwo(accountType)}</div>

        <RadioGroupField
          title={getRadioTitle(accountType)}
          onChange={handleRothHoldingsAfterTax}
          options={radioOptions}
          name="rothHoldingsAfterTax"
        />
      </div>

      <div className="button-container">
        <MFBeaconButton
          className="continue-button"
          id="rpsRolloverAdditionalFundsContinueBtn"
          data-name="rpsRolloverAdditionalFundsContinueBtn"
          variant="primary"
          size="normal"
          onClick={next()}
          disabled={!shouldEnableContinueBtn}
          label="Continue"
        />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RPSOneCallRolloverAdditionalFundsScreen;
